import { render } from "./lightholmprivacypolicy.vue?vue&type=template&id=4e9d977c&scoped=true"
import script from "./lightholmprivacypolicy.vue?vue&type=script&lang=js"
export * from "./lightholmprivacypolicy.vue?vue&type=script&lang=js"

import "./lightholmprivacypolicy.vue?vue&type=style&index=0&id=4e9d977c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9d977c"]])

export default __exports__